import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiGithub, FiFigma, FiSlack, FiCpu, FiTerminal, FiGlobe } = FiIcons;

const tools = [
  { name: 'GitHub', icon: FiGithub },
  { name: 'Figma', icon: FiFigma },
  { name: 'VS Code', icon: FiTerminal },
  { name: 'Linear', icon: FiCpu },
  { name: 'Slack', icon: FiSlack },
  { name: 'Vercel', icon: FiGlobe }
];

export default function IntegrationsTicker() {
  return (
    <section className="py-20 border-y border-white/5 bg-slate-950 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 mb-12 text-center">
        <p className="text-[10px] font-black uppercase tracking-[0.4em] text-slate-600">Syncs with your stack</p>
      </div>
      
      <div className="flex space-x-12 whitespace-nowrap overflow-hidden relative">
        <div className="absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-slate-950 to-transparent z-10" />
        <div className="absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-slate-950 to-transparent z-10" />
        
        <motion.div 
          animate={{ x: [0, -1000] }}
          transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
          className="flex space-x-12 items-center"
        >
          {[...tools, ...tools, ...tools].map((tool, i) => (
            <div key={i} className="flex items-center space-x-3 grayscale opacity-30 hover:grayscale-0 hover:opacity-100 transition-all cursor-default group">
              <SafeIcon icon={tool.icon} className="w-6 h-6 text-white group-hover:text-indigo-400" />
              <span className="text-xl font-black text-white uppercase italic tracking-tighter">{tool.name}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}